/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // ========================================
  // PRODUCT GRID ALWAYS-ON SLIDESHOW
  // Replaces hover-only slideshow with:
  // - Desktop: always visible, nav arrows on hover
  // - Mobile: swipeable, no nav arrows
  // ========================================
  function initProductGridSlideshows() {
    const slideshowHolders = document.querySelectorAll(
      "hover-slideshow .product__media__slider--always, div .product__media__slider--always",
    );
    slideshowHolders.forEach(function (holder) {
      initSingleSlideshow(holder);
    });
  }

  function initSingleSlideshow(holder) {
    const parent =
      holder.closest(".product__media__container") ||
      holder.closest(".product-grid-item__image");
    if (!parent || holder.dataset.slideshowInit === "true") return;
    holder.dataset.slideshowInit = "true";

    const slides = holder.querySelectorAll("[data-hover-slideshow-item]");
    if (slides.length <= 1) return;

    // Destroy any Flickity instance that the theme may have created
    if (window.theme && window.theme.Flickity) {
      try {
        var flktyInstance = window.theme.Flickity.data(holder);
        if (flktyInstance && flktyInstance.isActive) {
          flktyInstance.destroy();
        }
      } catch (e) {
        /* ignore */
      }
    }

    const navContainer = parent.querySelector("[data-slideshow-nav]");
    const progressContainer = parent.querySelector("[data-slideshow-progress]");
    const prevBtn = parent.querySelector("[data-slideshow-prev]");
    const nextBtn = parent.querySelector("[data-slideshow-next]");
    const segments = progressContainer
      ? progressContainer.querySelectorAll("[data-progress-segment]")
      : [];

    let currentIndex = 0;
    const totalSlides = slides.length;

    // Lazy-load: defer loading of non-first slide images
    // Move src/srcset to data-src/data-srcset for slides beyond the first
    slides.forEach(function (slide, i) {
      if (i === 0) return; // Keep first slide (featured image) loaded
      var imgs = slide.querySelectorAll("img[src], img[srcset]");
      imgs.forEach(function (img) {
        if (img.getAttribute("src")) {
          img.setAttribute("data-lazy-src", img.getAttribute("src"));
          img.removeAttribute("src");
        }
        if (img.getAttribute("srcset")) {
          img.setAttribute("data-lazy-srcset", img.getAttribute("srcset"));
          img.removeAttribute("srcset");
        }
      });
      var sources = slide.querySelectorAll("source[srcset]");
      sources.forEach(function (source) {
        source.setAttribute("data-lazy-srcset", source.getAttribute("srcset"));
        source.removeAttribute("srcset");
      });
    });

    // Load images for a specific slide
    function loadSlideImages(slideIndex) {
      var slide = slides[slideIndex];
      if (!slide || slide.dataset.imagesLoaded === "true") return;
      slide.dataset.imagesLoaded = "true";
      var imgs = slide.querySelectorAll(
        "img[data-lazy-src], img[data-lazy-srcset]",
      );
      imgs.forEach(function (img) {
        if (img.getAttribute("data-lazy-srcset")) {
          img.setAttribute("srcset", img.getAttribute("data-lazy-srcset"));
          img.removeAttribute("data-lazy-srcset");
        }
        if (img.getAttribute("data-lazy-src")) {
          img.setAttribute("src", img.getAttribute("data-lazy-src"));
          img.removeAttribute("data-lazy-src");
        }
      });
      var sources = slide.querySelectorAll("source[data-lazy-srcset]");
      sources.forEach(function (source) {
        source.setAttribute("srcset", source.getAttribute("data-lazy-srcset"));
        source.removeAttribute("data-lazy-srcset");
      });
    }

    // Preload adjacent slides
    function preloadAdjacentSlides(index) {
      var next = (index + 1) % totalSlides;
      var prev = (index - 1 + totalSlides) % totalSlides;
      loadSlideImages(next);
      loadSlideImages(prev);
    }

    // Mark first slide as loaded and preload its neighbors
    slides[0].dataset.imagesLoaded = "true";
    preloadAdjacentSlides(0);

    // Position slides side by side — no transition on init to avoid flash
    slides.forEach(function (slide, i) {
      slide.style.position = "absolute";
      slide.style.top = "0";
      slide.style.left = "0";
      slide.style.width = "100%";
      slide.style.height = "100%";
      slide.style.transition = "none";
      slide.style.transform = "translateX(" + i * 100 + "%)";
    });

    // Mark as initialized — CSS will now show all slides
    holder.classList.add("is-initialized");

    // Enable transitions after initial positioning is painted
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        slides.forEach(function (slide) {
          slide.style.transition =
            "transform 0.35s cubic-bezier(0.25, 0.1, 0.25, 1)";
        });
      });
    });

    function goToSlide(index) {
      if (index < 0) index = totalSlides - 1;
      if (index >= totalSlides) index = 0;
      currentIndex = index;

      // Load current and adjacent slide images
      loadSlideImages(currentIndex);
      preloadAdjacentSlides(currentIndex);

      slides.forEach(function (slide, i) {
        slide.style.transform = "translateX(" + (i - currentIndex) * 100 + "%)";
      });

      // Update progress bar — fill all segments up to current
      segments.forEach(function (seg, i) {
        seg.classList.toggle("is-active", i <= currentIndex);
      });
    }

    // Navigation buttons
    if (prevBtn) {
      prevBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        goToSlide(currentIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        goToSlide(currentIndex + 1);
      });
    }

    // Progress segment navigation
    segments.forEach(function (seg) {
      seg.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var idx = parseInt(seg.getAttribute("data-progress-segment"), 10);
        goToSlide(idx);
      });
    });

    // Touch/Swipe support for mobile
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let isSwiping = false;
    const swipeThreshold = 40;

    holder.addEventListener(
      "touchstart",
      function (e) {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
        isSwiping = false;
      },
      { passive: true },
    );

    holder.addEventListener(
      "touchmove",
      function (e) {
        const diffX = Math.abs(e.changedTouches[0].screenX - touchStartX);
        const diffY = Math.abs(e.changedTouches[0].screenY - touchStartY);
        if (diffX > diffY && diffX > 10) {
          isSwiping = true;
          e.preventDefault();
        }
      },
      { passive: false },
    );

    holder.addEventListener(
      "touchend",
      function (e) {
        if (!isSwiping) return;
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > swipeThreshold) {
          if (diff > 0) {
            goToSlide(currentIndex + 1);
          } else {
            goToSlide(currentIndex - 1);
          }
        }
      },
      { passive: true },
    );

    // Prevent link navigation when swiping
    holder.closest("a")?.addEventListener("click", function (e) {
      if (isSwiping) {
        e.preventDefault();
      }
    });
  }

  // Initialize on DOM ready with a slight delay to ensure theme JS has run
  setTimeout(initProductGridSlideshows, 200);

  // Re-initialize after Shopify section changes, AJAX loads, etc.
  document.addEventListener("shopify:section:load", function () {
    setTimeout(initProductGridSlideshows, 300);
  });

  // Watch for dynamically loaded content (Ajaxinate, etc.)
  const observer = new MutationObserver(function (mutations) {
    let shouldInit = false;
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (
          node.nodeType === 1 &&
          (node.querySelector?.(".product__media__slider--always") ||
            node.classList?.contains("product__media__slider--always"))
        ) {
          shouldInit = true;
        }
      });
    });
    if (shouldInit) {
      setTimeout(initProductGridSlideshows, 100);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // ========================================
  // END PRODUCT GRID SLIDESHOW
  // ========================================

  // ========================================
  // FILTER COUNT BADGE
  // Syncs active filter count from [data-filter-count]
  // to the toggle button badge [data-toggle-filters-count]
  // ========================================
  function syncFilterCountBadge() {
    const countEl = document.querySelector("[data-filter-count]");
    const badge = document.querySelector("[data-toggle-filters-count]");
    if (!countEl || !badge) return;
    const count = parseInt(countEl.getAttribute("data-filter-count"), 10) || 0;
    badge.textContent = count > 0 ? count : "";
  }

  syncFilterCountBadge();

  // Re-sync after AJAX filter updates (theme re-renders [data-collection-filters] and [data-collection-products])
  const filterObserverTarget =
    document.querySelector("[data-collection-filters]") ||
    document.querySelector("[data-collection-products]")?.parentNode;
  if (filterObserverTarget) {
    const filterObserver = new MutationObserver(function () {
      setTimeout(syncFilterCountBadge, 100);
    });
    filterObserver.observe(filterObserverTarget, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener("shopify:section:load", function () {
    setTimeout(syncFilterCountBadge, 300);
  });
  // ========================================
  // END FILTER COUNT BADGE
  // ========================================

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
